import React, { FC, useState } from 'react';
import './style.scss';
import Modal from '../../../screens/Products/Plural/Login/components/Modal';
import notify from '../../../lib/notifiy';
import imgURL from '../../../lib/imgURL';

import Props from './typing';
import './style.scss';
import { fetchMerchantAction, updateLiveMerchantStatusAction } from '../../../redux/actions/login';
import { connect } from 'react-redux';
import { setCurrentRoute, setIsLiveMerchant } from '../../../lib/localStorage';
import TextInput from '../../../components/TextInput';
import { UiRoutes } from '../../../lib/constants';
import useRedirect from '../../../hooks/useRedirect';
import { togglePath } from './constants';

const SwitchAccountModal: FC<Props> = (props): JSX.Element => {
  const { push, path } = useRedirect();
  const { fetchMerchantAction, updateLiveMerchantStatusAction } = props;
  const [searchKey, setSearchKey] = useState('');
  const { UserEmail } = props.loginState;
  const entityTpe = {
    '8': 'Sole Proprietor',
    '9': 'Partnership Firm',
    '10': 'Private Limited Company',
    '11': 'Limited Liability Partnership Firm',
    '12': 'Trust',
    '13': 'Public Limited Company',
    '14': 'Societies',
    '15': 'OPC',
  };

  const fetchMerchantDetails = (detail) => {
    if ('isLiveMerchant' in detail) {
      setIsLiveMerchant(`${detail.isLiveMerchant}`);
      updateLiveMerchantStatusAction(`${detail.isLiveMerchant}`);
    }
    fetchMerchantAction({
      merchantId: detail.merchantId,
      email: UserEmail,
    });
    props.handleClose();

    const selectedMerhchant = props.MerchantList.filter(
      (item) => item.merchantId === detail.merchantId
    )[0];
    notify({
      message: 'Success',
      type: 'success',
      description: `Switched to Merchant - ${selectedMerhchant.merchantDisplayName} | MID: ${selectedMerhchant.productMerchantId}`,
    });
    if (path !== togglePath) {
      setCurrentRoute(path);
    }
    setTimeout(() => {push(UiRoutes.TOGGLEENV);},1000);
  };

  return (
    <React.Fragment>
      <Modal
        className={'switch-model'}
        backButtonEnable={false}
        onBackdropClick={() => props.handleClose && props.handleClose()}
      >
        <div className='multiple-merchant'>
          <div className='modal-header'>
            <div className='merchant-header'>
              <div className='message'>Choose an account</div>
              <div className='info'>
                You will be taken to the respective dashboard
              </div>
            </div>
            <img
              className='cursor-pointer'
              src={imgURL['cross-circle']}
              alt='Close'
              onClick={() => props.handleClose && props.handleClose()}
            />
          </div>
          {props.MerchantList.length > 5 ? (
            <>
              <TextInput
                placeholder={'Search Merchant'}
                name='Search'
                isRequired={true}
                handleChange={(e) => {
                  setSearchKey(e.target.value);
                }}
                value={searchKey}
              />
            </>
          ) : (
            <></>
          )}
          <div className='merchant-list'>
            {props.MerchantList.filter((item) => {
              if (searchKey === '') {
                return true;
              } else {
                return (
                  item?.merchantDisplayName
                    ?.toLowerCase()
                    .indexOf(searchKey?.toLowerCase()) > -1 ||
                  ('' + item?.merchantId)
                    ?.toLowerCase()
                    .indexOf(searchKey?.toLowerCase()) > -1 ||
                  ('' + item?.entityType)
                    ?.toLowerCase()
                    .indexOf(searchKey?.toLowerCase()) > -1
                );
              }
            }).map((detail, i) => {
              return (
                <div key={i} className={`item`}>
                  <div className='merchant-detail'>
                    <div className='merchant-name'>
                      {detail.merchantDisplayName}
                    </div>
                    <div className='merchant-id'>
                      {`MID: ${detail.productMerchantId}`}{' '}
                      {detail.entityType
                        ? `| ${entityTpe[detail.entityType]}`
                        : ''}
                    </div>
                  </div>
                  {detail.merchantId !== props.merchantId && detail.testMerchantId !== props.merchantId  ? (
                    <div
                      className='merchant-action'
                      onClick={() => {
                        fetchMerchantDetails(detail);
                      }}
                    >
                      <img src={imgURL['arrow-circle-right']} />
                    </div>
                  ) : (
                    <div className='merchant-action'>Active Account</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};
const mapStateToProps = ({ loginReducer }) => ({
  loginState: loginReducer.loginState,
  isAdmin: loginReducer.loginState.isAdmin,
  MerchantList: loginReducer.loginState.MerchantList,
});

export default connect(mapStateToProps, {
  fetchMerchantAction,
  updateLiveMerchantStatusAction,
})(SwitchAccountModal);
